enum InvoiceStatus {
    DRAFT = "draft",
    SENT = "sent",
    MANUALLY_SENT = "manually_sent",
    PAID = "paid",
    CANCELLED = "cancelled"
}

export default InvoiceStatus;
